<nz-drawer
  [nzVisible]="collapse"
  [nzPlacement]="dir === 'rtl' ? 'left' : 'right'"
  [nzWidth]="500"
  (nzOnClose)="toggle()"
>
  <div *nzDrawerContent class="setting-drawer__content">
    <div class="setting-drawer__body setting-drawer__theme">
      <h3 class="setting-drawer__title">主题色</h3>
      @for (c of colors; track $index) {
        <span
          [style]="{ 'background-color': c.color }"
          (click)="changeColor(c.color)"
          nz-tooltip
          [nzTooltipTitle]="c.key"
          class="setting-drawer__theme-tag"
        >
          @if (color === c.color) {
            <nz-icon nzType="check" />
          }
        </span>
      }
    </div>
    <nz-divider />
    <div class="setting-drawer__body">
      <h3 class="setting-drawer__title">设置</h3>
      <nz-tabset>
        <nz-tab nzTitle="顶部">
          <div class="setting-drawer__body">
            <setting-drawer-item [data]="data['alain-default-header-hg']" />
            <setting-drawer-item [data]="data['alain-default-header-bg']" />
            <setting-drawer-item [data]="data['alain-default-header-padding']" />
          </div>
        </nz-tab>
        <nz-tab nzTitle="侧边栏">
          <setting-drawer-item [data]="data['alain-default-aside-wd']" />
          <setting-drawer-item [data]="data['alain-default-aside-bg']" />
          <setting-drawer-item [data]="data['alain-default-aside-collapsed-wd']" />
          <setting-drawer-item [data]="data['alain-default-aside-nav-padding-top-bottom']" />
        </nz-tab>
        <nz-tab nzTitle="内容">
          <setting-drawer-item [data]="data['alain-default-content-bg']" />
          <setting-drawer-item [data]="data['alain-default-content-heading-bg']" />
          <setting-drawer-item [data]="data['alain-default-content-heading-border']" />
          <setting-drawer-item [data]="data['alain-default-content-padding']" />
        </nz-tab>
        <nz-tab nzTitle="其它">
          <setting-drawer-item [data]="data['form-state-visual-feedback-enabled']" />
          <setting-drawer-item [data]="data['preserve-white-spaces-enabled']" />
          <setting-drawer-item [data]="data['nz-table-img-radius']" />
          <setting-drawer-item [data]="data['nz-table-img-margin-right']" />
          <setting-drawer-item [data]="data['nz-table-img-max-width']" />
          <setting-drawer-item [data]="data['nz-table-img-max-height']" />
        </nz-tab>
      </nz-tabset>
    </div>
    <nz-divider />
    <div class="setting-drawer__body">
      <div class="setting-drawer__body-item">
        固定头和侧边栏
        <nz-switch nzSize="small" [(ngModel)]="layout.fixed" (ngModelChange)="setLayout('fixed', layout.fixed)" />
      </div>
      <div class="setting-drawer__body-item">
        色弱模式
        <nz-switch
          nzSize="small"
          [(ngModel)]="layout.colorWeak"
          (ngModelChange)="setLayout('colorWeak', layout.colorWeak)"
        />
      </div>
    </div>
    <nz-divider />
    <button (click)="apply()" type="button" nz-button nzType="primary">预览</button>
    <button (click)="reset()" type="button" nz-button>重置</button>
    <button (click)="copyVar()" type="button" nz-button>拷贝</button>
    <nz-alert
      class="mt-md"
      nzType="warning"
      nzMessage="配置栏只在开发环境用于预览，生产环境不会展现，请拷贝后手动修改参数配置文件 src/styles/theme.less"
    />
  </div>
</nz-drawer>
<div
  class="setting-drawer__handle"
  [class.setting-drawer__handle-opened]="collapse"
  (click)="toggle()"
  nz-tooltip
  [nzTooltipTitle]="isDev ? devTips : null"
>
  <nz-icon [nzType]="!collapse ? 'setting' : 'close'" class="setting-drawer__handle-icon" />
</div>
